import { IProduct } from 'mod/product/interface';
import { ListProductProps } from '@base/snippets/ListProduct';
import { IListItem } from 'mod/product-list/interface';
import { IModFeature } from 'mod/featureV2/interface';
import { IBanner as IBannerV2 } from 'mod/featureV2/interface/banner';

export const bannerTypes = [
    'swiperBanner',
    'tiledBanner',
    'twoColumnBanners', //pc首页
    'threeColumnBanners', //pc首页
] as const;

export const pointsMallTypes = [
    'pointsProduct',    // 积分商城列表
    'pointsFlashSale',   // 积分商城flashsale
    'pointsCheckIn'           // 积分签到
] as const;

export const productListTypes = [
    // homepage
    'limitedTimeList',
    // weekly deal
    'highlyRecommended',
    'discountList',
    'swiperProducts',
] as const;

// banner 点击展示弹窗
export type IPopupsCode = 'popup:blackFridaySignIn' | 'drawer:blackFridaySignIn'
export type IPopupShowType = 'popup' | 'drawer';
export type IPopupModalCode = 'blackFridaySignIn';

// 通用
export interface IBanner {
    picUrl?: string;
    videoUrl?: string;
    videoBackUpUrl?: string;
    linkUrl?: string;
    target?: '_blank' | '_self';
    largePicUrl?: string;
    altText?: string;
    bgColor?: string;
    width?: number;
    height?: number;
    popUps?: IPopupsCode
}

export type IAsset = {
    picUrl?: string;
    videoUrl?: string;
    altText?: string;
    cover?: string; // 缩略图
}
// 首页blog列表
export interface IBlog {
    picUrl: string;
    linkUrl: string;
    altText: string;
    desc: string;
    tags: string[];
}

// h5首页分类导航列表
export interface INavigation {
    linkUrl: string;
    picUrl: string;
    title: string;
    titleCode: string;
}

// h5首页分类导航列表
export interface IGridNav {
    url: string;
    title: string;
    desc: string;
}

// h5首页选项卡商品列表
export interface IProdctListTab {
    listSn: string;
    listTitle: string;
    listUrl: string;
}

/**
 * T: type
 * I: list item
 * C: module config
 */
export type IFeatureCreator<T, I, C = {}> = {
    type: T;
    lists: I[];
    config: C;
    moduleId: string;
    title: string;
    readMoreTitle: string;
    readMoreLink: string;
    endTimeStamp: number;
    discountShowPlace: 'left' | 'right';
    listSn: string,
    space: {
        marginTop: number;
        marginBottom: number;
        paddingTop: number;
        paddingBottom: number;
    },
    background: {
        color: string;
        image: string;
    },
};

export type ILocationCode = 'product:feature:middle' | 'product:feature:topRight'

export type IOldFeatureBanner = IFeatureCreator<typeof bannerTypes[number], IBanner, {
    width?: number; //图片宽度
    height: number; //图片高度
    column: 1 | 2 | 3; //列数
    spaceBetweenColumns: number; //两列之间的间距
    locationCode: ILocationCode; // 页面位置
    carouselFlag: 0 | 1; // banner 自动轮播控制
    hasSideSpace: 0 | 1; // 是否左右留白
}>;

export type IFeatureProduct = IFeatureCreator<typeof productListTypes[number], IListItem | null, {
    columnWidth: number; //列宽度
    spaceBetweenColumns: number; //两列之间的间距
    spaceAroundPicture: number; //图片四周空白距离
    spaceBelowPicture: number; //图片与标题间的距离
    showProductTag: boolean; //是否显示商品tag
    showActivityTag: boolean; //是否显示活动tag
    showTag: boolean; //是否显示tag
    elements: ListProductProps['elements']; //显示的商品信息
    listLimit: number;      // 普通列表长度
}>

//  feature super flash sale、flash sale 合并
export type IFeatureSwiperFlashsaleProducts = IFeatureCreator<'swiperFlashsaleProducts', ISFSProduct, {
    columnWidth: number; //列宽度
    spaceBetweenColumns: number; //两列之间的间距
    spaceAroundPicture: number; //图片四周空白距离
    spaceBelowPicture: number; //图片与标题间的距离
    showProductTag: boolean; //是否显示商品tag
    showActivityTag: boolean; //是否显示活动tag
    showTag: boolean; //是否显示tag
    elements: ListProductProps['elements']; //显示的商品信息
    startTime: number;      // Super Flashsale 开始时间
    endTime: number;        // Super Flashsale 结束
    listLimit: number;      // 普通列表长度
    superFlashsaleLimit: number;    // Super Flashsale 列表长度
}> & {
    hasSuperFlashsale: boolean; // 是否有Super Flashsale
};

export type IFeatureProdctListTabs = IFeatureCreator<'pageList', IProdctListTab>

export type IFeatureBlog = IFeatureCreator<'blog', IBlog>

export type IFeatureNavigation = IFeatureCreator<'navigation', INavigation>

export type IFeatureGridNav = IFeatureCreator<'gridNav', IGridNav>

export type IVideoBanner = {
    bgColor: string;
    picUrl: string;
    videoUrl: string;
    videoBackUpUrl?: string;
    largePicUrl: string;
    largeVideoUrl: string;
    largeVideoBackUpUrl?: string;
};

export type IFeatureVideoBanner = IFeatureCreator<'videoBanner', IVideoBanner, {
    height: number; //banner高度
    videoAutoDisplay: 0 | 1; // 自动轮播
    videoLoop: 0 | 1; // 循环轮播
    control: 0 | 1; // 自定义播放控制
    controls: 0 | 1; // 原生播放控制
}>;

// 黑五秒杀
export type ISFSProduct = {
    defaultVariant?: boolean; // 默认锚点到该商品
    startTime: number;
    endTime: number;
    userLimit: number;
    title: string;
    pic: string;
    previewPic: string;
    activityStock: number;
    priceLineChart: Array<{
        date: string;
        value: number;
    }>;
    variant: IProduct
};

// 评论
export type IReview = {
    userName?: string;   // 名字
    title?: string;      // 评论标题
    content?: string;    // 评论内容
    rate?: number;       // 评分
    images?: Array<IAsset>;
    variantId?: string;  // 商品变体id
}

//  feature 评论列表
export type IFeatureSwiperReviews = IFeatureCreator<'swiperReviews', IReview, {
    imageWidth?: number;
    imageHeight?: number;
    navigation?: boolean;
    pagination?: boolean;
}>;

//  feature 瀑布流
export type IFeatureWaterFall = IFeatureCreator<'waterFall', IBanner, {
    height: number;     //图片高度
    column?: number;    //列数
    spaceBetweenColumns?: number; //两列之间的间距
    viewMoreText?: string;  // viewMore 文案
    pageSize?: number;      // 每页数据
}>;

export type ICrowdFundingConfig = {
    activityCode: string;
    activityGid: number;
    endTimestamp: number;
    progressPercent: number;
    startTimestamp: number;
    targetAmountExchangeDisplay: string;
    title: string;
    desc: string;
    participantAmountExchangeDisplay: string;
    participantCount: string;

}
export type ICrowdFundingItem = {
    crowdFundingConfig: ICrowdFundingConfig
} & IBannerV2

//  feature 众筹
export type IFeatureCrowdFundingBanner = IFeatureCreator<'crowdFundingBanner', ICrowdFundingItem, {
    height: number;
    width: number;
}>;

export type ITabsItem = {
    background: {
        color?: string;
        image?: string;
    },
    showType: "dark" | "light",
    label: {
        text: string;
    }
    title: {
        text: string;
    }
    description: {
        text: string;
    }
    button: {
        button: string;
        linkUrl: string;
    },
    banner: IBannerV2;
    listSn?: string;
    variants?: string[];
    rowKey: string; // 前端添加key
}

export type IFeatureTabsProducts = IFeatureCreator<'tabsProducts', ITabsItem, {
    columnWidth?: number;   // 商品宽度
    listLimit?: number;     // 商品列表数据长度
    width?: number;         // banner宽
    height?: number;        // banner高
    elements?: ListProductProps['elements'];
}>

export type IFeatureSuperFlashSale = IFeatureCreator<'superFlashSale', ISFSProduct, {
    startTime: number;
    endTime: number;
}>

export type IFeaturePointsMall = IFeatureCreator<typeof pointsMallTypes[number], any>

export type IFeature =
    IModFeature
    | IFeatureVideoBanner
    | IOldFeatureBanner
    | IFeatureProduct
    | IFeatureSuperFlashSale
    | IFeatureSwiperFlashsaleProducts
    | IFeatureBlog
    | IFeatureNavigation
    | IFeatureGridNav
    | IFeatureProdctListTabs
    | IFeaturePointsMall
    | IFeatureSwiperReviews
    | IFeatureWaterFall
    | IFeatureCrowdFundingBanner
    | IFeatureTabsProducts
    ;
